const about_US_Locale = {
    'about.about': 'About Us',
    'about.honors': 'Honors and Qualifications',
    'about.culture': 'Corporate Culture',
    'about.aboutRayshape': 'About RayShape',
    'about.rayshape': 'RayShape',
    'about.rayshapeIntroduce': 'RayShape was founded in 2019 and is headquartered in Shenzhen. It is a national high-tech enterprise continuously focused on the development of full-stack intelligent ultrasound products. With nearly 20 years of expertise in the intelligent ultrasound field, the team has made significant breakthroughs and productized solutions in areas such as intelligent disease screening, ultrasound imaging quality control, all-in-one intelligent annotation, dynamic high-dimensional ultrasound AI algorithms, and universal AI model deployment frameworks. Our products now comprehensively cover multiple clinical areas including obstetrics and gynecology, cardiology, superficial organs, and abdominal imaging.',
    'about.foundingYear': 'Founding Year',
    'about.YearsOf': 'Years of',
    'about.Expertise': 'Expertise in the',
    'about.fieId': 'Intelligent Ultrasound Field',
    'about.numberOf': 'Number of ',
    'about.Authorized': 'Authorized Intelligent',
    'about.Applications': 'Ultrasound Applications',
    'about.corePatents': 'Core Patents and',
    'about.software': 'Software Copyrights',
    'about.TheUItrasound': 'in The Ultrasound Field',
    'about.DevelopmentHistory': 'Development History',
    'about.PartnerHospitals': 'Partner Hospitals',
    'about.scrollListArrTitle1': "Chinese People's Liberation Army (PLA) General Hospital",
    'about.scrollListArrTitle2': 'Suzhou Municipal Hospital',
    'about.scrollListArrTitle3': 'Tongji Hospital',
    'about.scrollListArrTitle4': 'Maternal and Child Health Hospital of Hubei Province',
    'about.scrollListArrTitle5': 'Ruijin Hospital, Shanghai Jiaotong University School of Medicine',
    'about.scrollListArrTitle6': 'Qilu Hospital of Shandong University',
    'about.scrollListArrTitle7': 'Shengjing Hospital affiliated to China Medical University',
    'about.scrollListArrTitle8': "Northwest Women's and Children's Hospital",
    'about.scrollListArrTitle9': 'Sichuan Provincial Maternity and Child Health Care Hospital',
    'about.scrollListArrTitle10': "Children's Hospital of Chongqing Medical University",
    'about.scrollListArrTitle11': 'The Third Xiangya Hospital of Central South University',
    'about.scrollListArrTitle12': 'Hunan Province Maternal and Child Health Care Hospital',
    'about.scrollListArrTitle13': 'The Second Affiliated Hospital, Sun Yat-sen University)',
    'about.scrollListArrTitle15': "Shenzhen People's Hospital",
    'about.scrollListArrTitle16': "Shenzhen Luohu Hospital Group Luohu People's Hospital",
    'about.scrollListArrTitle17': 'The Peoples Hospital of Guangxi Zhuang Autonomous Region',
    'about.scrollListArrTitle18': 'Fujian Province Maternal and Child Health Care Hospital',
    'about.scrollListArrTitle19': "Zhejiang Provincial People's Hospital",
    'about.scrollListArrTitle20': 'The Second Affiliated Hospital of Nanchang University',
    'about.scrollListArrTitle21': 'The First Peoples Hospital of Foshan',
    'about.scrollListArrTitle22': 'Yunnan Province Maternal and Child Health Care Hospital',
    'about.scrollListArrTitle23': "People's Hospital of Xinjiang Uygur Autonomous Region",
    'about.contactUs': 'Contact Us',
    'about.Name': 'Name',
    'about.phoneNumber': 'Phone Number',
    'about.OrganizationName': 'Organization Name',
    'about.Suggestions': 'Write Down Your Needs and Suggestions',
    'about.SubmitMessage': 'Submit Message',
    'about.honorTime1': '2021',
    'about.honorContent1': "National High-tech Enterprise Certification",
    'about.honorTime2': 'ISO13485',
    'about.honorContent2': "Medical Device Quality Management System;",
    'about.honorTime3': 'ISO27001',
    'about.honorContent3': "Information Security Management System",
    'about.honorTime4': '2023',
    'about.honorContent4': "Conducting a national key research program for multicenter clinical research on intelligent prenatal ultrasound",
    'about.honorTime5': '2021',
    'about.honorContent5': "First NMPA Registration Certificate for Pelvic Floor Ultrasound Imaging Processing Software",
    'about.honorTime6': '2022',
    'about.honorContent6': "First NMPA Registration Certificate for Intelligent Ultrasound Assisted Screening of Infant Hip Joint.",
    'about.honorTime7': '2023',
    'about.honorContent7': "First NMPA Registration Certificate for Prenatal Ultrasound Imaging Processing Software",
    'about.honorTime8': '2024',
    'about.honorContent8': "NMPA Registration Certificate for Breast Ultrasound Imaging Processing Software",
    'about.honorTime9': '2022',
    'about.honorContent9': "Ranked first in publications in top international intelligent medical imaging journals, with 15,000+ citations in core journals on Google.",
    'about.honorTime10': '2023',
    'about.honorContent10': "Over 40 Core Patents and Software Copyrights in the Ultrasound Field",
    'about.culturalTitle1': "Customer First",
    'about.culturalContent1': 'We adhere to the customer-first philosophy, continuously optimizing our products and services to provide users with a better experience.',
    'about.culturalTitle2': "Innovative & Focus",
    'about.culturalContent2': "We prioritize innovation as the core strategy for our company's development, dedicated to creating leading medical technology products and solutions.",
    'about.culturalTitle3': "Responsible",
    'about.culturalContent3': 'We take on the mission of being accountable, unafraid of challenges, and boldly exploring innovation to provide users with high-quality medical products.',
    'about.culturalTitle4': "Joyful & Equal",
    'about.culturalContent4': 'We aim to create an open and inclusive RayShape family, working hand in hand with employees to ensure that everyone has a positive work environment and ample opportunities for growth.',
    'about.culturalImgTitle1': 'Empowering "Supermen" to be even more super',
    'about.culturalImgContent1': 'A brand new product concept and product layout focus on key aspects such as imaging optimization, scanning navigation, standardized data collection, quantitative quality control, and auxiliary diagnosis. By leveraging artificial intelligence, we effectively enhance the efficiency of ultrasound screening, reduce diagnostic discrepancies, and comprehensively expand the clinical applications of ultrasound.',
    'about.culturalImgTitle2': 'Mission',
    'about.culturalImgContent2': 'Using AI technology to benefit human health',
    'about.culturalImgTitle3': 'Vision',
    'about.culturalImgContent3_1': 'Improve the standardization and accessibility of ultrasound diagnostics',
    'about.culturalImgContent3_2': 'Strive to become a global leader in intelligent ultrasound',
    'about.hospitalsName1':'Shenzhen, China',
    'about.hospitalsName2':'Beijing, China',
    'about.hospitalsName3':'Shanghai, China',
    'about.hospitalsName4':'Guangzhou, China',
    'about.hospitalsName5':'Chengdu, China',
}
export default about_US_Locale
